window.VegasCart = {
	add: function ($self) {
		let $product = $self.closest('[data-cart=product]');
		let id = $self.data('id') || $product.data('id');
		let cnt = $product.find('input[name=cnt]').val() || 1;
		let variant_id = $product.find('select[name=variant_id]').val();

		let params = VegasCart.formData({id: id, variant_id: variant_id, cnt: cnt});

		this.addRequest(params, function (data) {
			if (!data.error) {
				VegasCart.total(data);
				$product.addClass('in-cart');

				VegasCart.popup($product.data('title'), true);
			}
		});
	},

	addRequest: function (params, callback) {
		$.post('/cart/add_product', params, function (data) {
			if (typeof callback == 'function')
				callback(data);
		});
	},

	changeCnt: function ($self) {
		let $product = $self.closest('[data-cart=product]');
		let id = $product.data('id');
		let pivot_id = $product.data('pivot_id');
		let cnt = $product.find('input[name=cnt]').val() || 1;
		let params = VegasCart.formData({
			id: id,
			pivot_id: pivot_id,
			cnt: cnt,
			get_products_totals: true,
		});

		$.post('/cart/change_product', params, function (data) {
			VegasCart.total(data);
		});
	},

	remove: function ($self) {
		let $product = $self.closest('[data-cart=product]');
		let id = $product.data('id');
		let pivot_id = $product.data('pivot_id');
		let params = VegasCart.formData({
			id: id,
			pivot_id: pivot_id,
		});

		let rowsCount = parseInt($('.cart-table [data-cart=product]:visible').length) - 1;

		this.removeRequest(params, function (data) {
			VegasCart.total(data);

			$product.fadeOut();
			if (rowsCount === 0) location.reload();
		});
	},

	removeRequest: function (params, callback) {
		$.post('/cart/del_product', params, function (data) {
			if (typeof callback == 'function')
				callback(data);
		});
	},

	total: function (data) {
		if (typeof data.products_count !== 'undefined') {
			$('[data-cart=products-count]').attr('data-cnt', data.products_count);
		}

		if (typeof data.cart_sum_formatted !== 'undefined') {
			$('[data-cart="cart-total"]').html(data.cart_sum_formatted);
		}

		this.totalProducts(data);
		this.totalCartProductView(data);
		this.totalOrder(data);
	},

	totalOrder: function(data) {
		if (typeof data.sums === 'undefined') return false;

		if (typeof data.sums.sum_delivery !== 'undefined') {
			var text = data.sums.sum_delivery;
			if (text == '') text = 'Бесплатно';
			else text = output_roubles(text);

			$('.vg-catalog-order').find('[data-cart=order-delivery-sum]').html(text);
		}

		if (typeof data.sums.sum !== 'undefined') {
			$('[data-cart=order-all-sum]').html(output_roubles(data.sums.sum));
		}
	},

	totalProducts: function (data) {
		if (typeof data.products_totals !== 'undefined') {
			for (let i in data.products_totals) {
				let item = data.products_totals[i];
				$('.cart-table .cart-prd[data-pivot_id="' + item.pivot_id + '"] .price-total').text(item.price_total_formatted);
			}
		}
	},

	totalCartProductView(data) {
		if (typeof data.product_cart_view !== 'undefined') {
			for (let i in data.product_cart_view) {
				let item = data.product_cart_view[i];

				$cartItem = $('.cart-product[data-pivot_id="' + item.pivot_id + '"]');
				$cartItem.after(item.view);
				$cartItem.remove();
			}
		}
	},

	updateTotalAll: function () {
		$.get('/cart/get_totals', VegasCart.formData(), function (data) {
			VegasCart.total(data);
		});
	},

	formData: function (appendParams) {
		appendParams = appendParams || {};
		let resultParams = [];

		for (let name in appendParams) {
			resultParams.push({name: name, value: appendParams[name]});
		}

		resultParams.push({name: '_token', value: App.csrf});

		return resultParams;
	},

	popup: function (title, status = false) {
		let $modal = $('#modalCartProduct');

		$modal.find('.modal-content .title').text(title);

		$modal.modal('show');
		$modal.closest('body').find('.modal-backdrop.in').hide();
	}
};

window.VegasCart.Order = {
	updateData: function ($form) {
		var params = $form.serializeArray();

		$.get('/cart/order/data', params, function (data) {
			VegasCart.total(data);
		});
	}
} ;

/**
 * Прослушиватели событий корзины
 **/
let $window = $(window),
	$body = $('body'),
	$document = $(document)
;

$document.on('click', '[data-cart=add]', function () {
	VegasCart.add($(this), 1);
	return false;
});

$document.on('click', '[data-cart=remove]', function () {
	VegasCart.remove($(this), 1);
	return false;
});

$document.on('click', '.cart-table .qtybutton', function () {
	let $self = $(this),
		sign = $self.text(),
		$container = $self.closest('.count-items'),
		$input = $container.find('input[name=cnt]'),
		cnt = $input.val() || 1;

	if (sign === '-') {
		if (cnt > 1) cnt--;
	} else {
		cnt++;
	}

	$input.val(cnt);

	VegasCart.changeCnt($self);

	return false;
});

$document.on('click', '[data-cart=count-items]', function () {
	let $self = $(this),
		sign = $self.data('sign'),
		$container = $self.closest('.vg-widget-count-items'),
		$input = $container.find('input[name=cnt]'),
		cnt = $input.val() || 1;

	if (sign === 'minus') {
		if (cnt > 1) {
			cnt--;
		}
	} else {
		cnt++;
	}

	$input.val(cnt);

	VegasCart.changeCnt($self);

	return false;
});

$document.on('change', '[data-cart=product] select[name=variant_id]', function () {
	let $self = $(this),
		$prd = $self.closest('[data-cart=product]'),
		$price = $prd.find('.price-area span'),
		price = $self.find('option:selected').attr('data-price')
	;

	$prd.attr('data-price', price);
	$price.html(price);

	return false;
});
